import React from 'react';
import { createMultipleEntityPickerEditor } from '..';
export default (options) => {
    const MultipleEntityPickerEditor = createMultipleEntityPickerEditor(options);
    return ({ value, setValue, propertyKey, propertyOptions, serverUrl }) => (React.createElement(MultipleEntityPickerEditor, Object.assign({ source: {}, serverUrl: serverUrl, value: [value].filter(Boolean), setValue: (newValue) => {
            setValue(newValue[newValue.length - 1]);
        }, propertyKey: propertyKey, propertyOptions: propertyOptions }, options, { max: 1 })));
};
